// 檢測頁面重整的工具
class PageRefreshDetector {
  constructor() {
    this.isPageRefresh = false;
    this.init();
  }

  init() {
    // 檢測是否為頁面重整
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation && navigation.type === 'reload') {
      this.isPageRefresh = true;
    }

    // 備用檢測方法：檢查 sessionStorage
    const refreshFlag = sessionStorage.getItem('pageRefreshFlag');
    if (!refreshFlag) {
      this.isPageRefresh = true;
      sessionStorage.setItem('pageRefreshFlag', 'true');
    }

    // 監聽 beforeunload 事件
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('pageRefreshFlag');
    });
  }

  isRefresh() {
    return this.isPageRefresh;
  }

  // 清除重整標記（用於手動清除緩存）
  clearRefreshFlag() {
    this.isPageRefresh = false;
    sessionStorage.removeItem('pageRefreshFlag');
  }
}

const pageRefreshDetector = new PageRefreshDetector();
export default pageRefreshDetector; 